import  styles from './Doc.module.css'
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import WorkLine from "../../FormTemplate/WorkLine/WorkLine";
import InputItem, {IRefInputItem} from "../../FormTemplate/InputItem/InputItem";
import SelectUnit, {SelectUnitDataInt} from "../../FormTemplate/SelectUnit/SelectUnit";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import React, {useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
export default function DocYota()
{
    const [genderList] = useState<SelectUnitDataInt[]>([
        {
            name: "Мужской",
            val: "M"

        },
        {
            name: "Женский",
            val: "F"

        },
    ])
    const [gender, setGender] = useState("")
    const refState = useRef<ErrorLineItemRef>(null)

    const [orderId, setOrderId] = useState("")
    const refOrder = useRef<IRefInputItem>(null)


    const [city, setCity] = useState("")
    const refCity = useRef<IRefInputItem>(null)


    const [fromOperId, setFromOperId] = useState("")
    const refOper = useRef<IRefInputItem>(null)


    const dataMnpDoc = useRef<{
        orderId:string
        city:string
        signer:number
        fromOper: string
    }>()
    const [ldrMnpDoc,rsMnpDoc,exMnpDoc] = useApiQuery("/doc/yota/mnp/statement","post",dataMnpDoc);



    const [signer, setSigner] = useState<number>(-1)
    const [signerList, setSignerList] = useState<SelectUnitDataInt[]>([
        {
            name: "ИП Титов Д.Ю.",
            val: 0,
        },
        {
            name: "ООО ФОРУМ",
            val: 1,
        },
    ])



    const [work, setWork] = useState(false)


    const handleMnpStatement = ()=>{
        if(!refState.current) return
        if(refOrder.current && !refOrder.current.validate())
        {
            refState.current.show("Номер заказа не коррекен",true, 3000)
            return;
        }
        if(refCity.current && !refCity.current.validate())
        {
            refState.current.show("Город заказа не корректен",true, 3000)
            return;
        }
        if(refOper.current && !refOper.current.validate())
        {
            refState.current.show("Оператор донор не корректен",true, 3000)
            return;
        }
        if(signer < 0)
        {
            refState.current.show("Подписант не выбран",true, 3000)
            return;
        }


        dataMnpDoc.current={
            orderId: orderId,
            city: city,
            signer: signer,
            fromOper: fromOperId
        }
        setWork(true)
        exMnpDoc().then((e)=>{
            setWork(false)
            if(e?.success)
            {
                try {
                    e?.payload.blob().then((blob: any) => {
                        const fileURL = window.URL.createObjectURL(blob);
                        let alink = document.createElement("a");
                        alink.href = fileURL;
                        alink.download = "SamplePDF.pdf";
                        alink.click();
                    })

                } catch (e) {
                    console.log(e)
                }
                return
            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,4000)
        })

    }



    return(
        <div className={styles.mainCont}>
            <MainFormTemplate title={"Документы Йота"} maxWidth={"1200px"} load={work}>
                <div className={"row"}>
                    <div className={"d-flex col-md-3"}>
                        <InputItem
                            ref={refOrder}
                            title={"Заказ"}
                            val={orderId}
                            mode={"ei"}
                            placeHolder={"Номер"}
                            info={"Номер заказа"}
                            regExp={/^[0-9\w]{3,}$/ui}
                            onChange={(e)=>setOrderId(e)}
                        />

                    </div>

                    <div className={"d-flex col-md-3"}>
                        <InputItem
                            ref={refCity}
                            title={"Город"}
                            val={city}
                            mode={"ei"}
                            placeHolder={"Город"}
                            info={"Город договора"}
                            regExp={/^[\w\W]{3,}$/ui}
                            onChange={(e)=>setCity(e)}
                        />

                    </div>
                    <div className={"d-flex col-md-3"}>
                        <InputItem
                            ref={refOper}
                            title={"Оператор"}
                            val={fromOperId}
                            mode={"ei"}
                            placeHolder={"Донор"}
                            info={"Имя оператора донора "}
                            regExp={/^[\w\W]{3,}$/ui}
                            onChange={(e)=>setFromOperId(e)}
                        />

                    </div>


                    <div className={"d-flex col-md-3"}>
                        <div className={styles.suCont}>
                            <SelectUnit
                                inData={signerList}
                                capt={"Подписант"}
                                getVal={(e)=>setSigner(e[0] !==undefined ? e[0] : -1)}
                            />

                        </div>
                    </div>



                </div>

                <div className={"row"}>
                    <ErrorLineItem ref={refState}></ErrorLineItem>
                </div>

                <div className={styles.btnCont}>
                    <button type="button" className="btn btn-secondary "
                            onClick={()=>handleMnpStatement()}
                    >Заявление [мнп]</button>

                </div>
            </MainFormTemplate>
        </div>
    )
}